export const compareArraysBasic = <T = string | number | boolean>(arr1: T[], arr2: T[]) => {
  if (arr1.length !== arr2.length) {
    return false;
  }
  return arr1.every((item, index) => item === arr2[index]);
};

export const compareArrays = <T>(arr1: T[], arr2: T[], keysToCompare: (keyof T)[]) => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  return arr1.every((item, index) => keysToCompare.every((key) => item[key] === arr2[index][key]));
};

export const compareObjects = <T>(obj1: Record<string, T>, obj2: Record<string, T>, keysToCompare: (keyof T)[]) => {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  return keys1.every((key) => {
    const item1 = obj1[key];
    const item2 = obj2[key];

    if (!item2) {
      return false;
    }

    return keysToCompare.every((compareKey) => item1[compareKey] === item2[compareKey]);
  });
};
